"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportType = void 0;
/**
 * 文件导入类型
 */
var ImportType;
(function (ImportType) {
    ImportType["MARKDOWN"] = "markdown";
    ImportType["CSV"] = "csv";
    ImportType["NOTION"] = "notion";
    ImportType["HTML"] = "html";
    ImportType["WORD"] = "word";
})(ImportType = exports.ImportType || (exports.ImportType = {}));
